import React from 'react';
import { Button, Image, Typography } from 'tfc-components';

import product1 from 'assets/images/product/product_1.png';
import product2 from 'assets/images/product/product_2.png';
import product3 from 'assets/images/product/product_3.png';
import productExtend from 'assets/images/product/product_extend.png';
import Section from 'components/organisms/Section';

interface IProduct {
  image: string;
  name: string;
  title: string;
  subTitle?: string;
  content: {
    title?: string;
    data: string[];
  };
  description: string;
  buttonTxt: string;
  tutorial?:string
}
const data: IProduct[] = [
  {
    image: product1,
    name: 'EVOL AI Tutor',
    title: 'A smarter way to learn. Built with AI.',
    content: {
      title:
        'EVOL AI Tutor is your personal learning companion. Designed for students who want to study smarter, not harder — it adapts to each learner’s pace, preferences, and goals.',
      data: ['Customized study plans based on personal learning goals', 'Real-time answers to academic questions', 'Smart revision using spaced repetition and memory techniques', 'Progress tracking with insights to improve study habits']
    },
    description: 'Currently reaches 10000+ high school and university users',
    buttonTxt: 'Explore now'
  },

  {
    image: product2,
    name: 'EVOL FIELD',
    title: 'AI-powered workforce intelligence for field teams.',
    subTitle: 'EVOL FIELD is a solution for businesses with distributed teams — sales reps, merchandisers, promoters, and operations in the field',
    content: {
      title:
        'What it does:',
      data: ['GPS-based check-in/out with facial recognition', 'Photo + location-based verification of field tasks', 'AI analysis of team interaction and engagement quality', 'Real-time dashboards for tracking performance, alerts, and attendance']
    },
    description: 'Perfect for: FMCG, logistics, staffing, tourism, and inspection teams.',
     buttonTxt: 'Learn more about EVOL FIELD'
  },

  {
    image: product3,
    name: 'EVOL Askly',
    title: 'Find what your team needs to know — instantly.',
    subTitle: 'EVOL Askly is an internal knowledge assistant that lets team members ask natural-language questions and get accurate, verified answers — without searching across tools.',
    content: {
      title:
        'Use Cases:',
      data: ['Answering HR and policy questions', 'Surfacing SOPs or training content', 'Helping support agents find correct workflows', 'Enabling faster onboarding for new hires']
    },
    tutorial: 'How it works:',
    description: 'Askly connects to your company’s documents, wiki, and data to provide secure, context-aware responses.',
     buttonTxt: 'Request demo for your team'
  },
];
const Products: React.FC = () => (
  <Section className="p-product">
    {
      data.map((item, index) => (
        <div className="p-product_item" key={`produce${index.toString()}`}>
          <div className="p-product_item_imgWrap">
            <Image imgSrc={item.image} alt={item.name} ratio={583 / 413} />
            <Image extendClasses="p-product_item_imgExtend" imgSrc={productExtend} alt={item.name} ratio={1} />
          </div>
          <div className="p-product_item_text">
            <Typography.Text fontweight="600" extendClasses="f-28x34">{item.name}</Typography.Text>
            <Typography.Text fontweight="600" extendClasses="p-product_item_title">{item.title}</Typography.Text>
            {item?.subTitle
                && <Typography.Text extendClasses="p-product_item_subTitle">{item.subTitle}</Typography.Text>}

            <div>
              <Typography.Text fontweight="600" extendClasses="p-product_item_contentTitle">{item.content.title}</Typography.Text>
              {item.content.data.map((content, contentIndex) => (
                <Typography.Text key={`product${contentIndex.toString()}`} extendClasses="p-product_item_content">{ content}</Typography.Text>
                 ))}
            </div>

            {item?.tutorial
                && <Typography.Text extendClasses="p-product_item_contentTitle" fontweight="600">{item.tutorial}</Typography.Text>}
            <Typography.Text extendClasses="p-product_item_description" fontweight="600">{item.description}</Typography.Text>
            <Button extendClasses="fButton">{item.buttonTxt}</Button>
          </div>
        </div>
      ))
    }

  </Section>
);

export default Products;
